import React, { useState } from "react";
import { Button, Dropdown } from "semantic-ui-react";
import { statusColorMap } from "../commitmentInstructions/helpers/statusColorMap";

export default function OmitsDropdown({
  omit,
  setOmitToUpdate,
  setNewOmitModalOpen,
  setOptionAttemptedToAdd,
  existingOmitOptions,
  updateTaskOmit,
  isSubtask,
  updateSubTaskOmit,
  taskId,
  statusTypes
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  return (
    <Dropdown
      onBlur={() => {
        setDropdownOpen(false);
        setSearchQuery("");
      }}
      open={dropdownOpen}
      search
      selection
      placeholder="Select an omit option"
      noResultsMessage={
        <Button
          onClick={() => {
            setOmitToUpdate({ omit, isSubtask, taskId });
            setNewOmitModalOpen(true);
          }}
        >
          Add New Omit Option
        </Button>
      }
      clearable
      style={{ flex: 1, marginRight: "8px" }}
      onChange={(e, { value }) => {
        if (e.type === "blur") return;
        if (isSubtask) {
          updateSubTaskOmit(taskId, omit.id, value);
        } else {
          updateTaskOmit(omit.id, value);
        }
      }}
      onSearchChange={(e, { searchQuery }) => {
        setOptionAttemptedToAdd(searchQuery);
        setSearchQuery(searchQuery);
      }}
      text={
        omit.text ? (
          <div>
            {omit.text}
            <span
              style={{
                color: statusColorMap[omit.statusApplicableTo],
                fontWeight: "bold"
              }}
            >
              {" "}
              ({statusTypes.find(t => t.id === omit.statusApplicableTo)?.description})
            </span>
          </div>
        ) : (
          "Select an omit option"
        )
      }
      render={({ search, filteredOptions }) => (
        <Button
          onClick={() => {
            setOmitToUpdate({ omit, isSubtask, taskId });
            setNewOmitModalOpen(true);
          }}
        >
          Add New Omit Option
        </Button>
      )}
      onClick={e => {
        setDropdownOpen(true);
      }}
    >
      <Dropdown.Menu>
        {existingOmitOptions.filter(option => option.text?.toLowerCase().includes(searchQuery?.toLowerCase())).length >
        0 ? (
          existingOmitOptions
            .filter(option => option.text?.toLowerCase().includes(searchQuery?.toLowerCase()))
            .map(option => (
              <Dropdown.Item
                key={option.key}
                value={option.value}
                onClick={e => {
                  e.stopPropagation();
                  if (e.type === "blur") return;
                  if (isSubtask) {
                    updateSubTaskOmit(taskId, omit.id, option.value);
                  } else {
                    updateTaskOmit(omit.id, option.value);
                  }
                  setDropdownOpen(false);
                }}
              >
                {option.text} <span style={{ color: option.color, fontWeight: "bold" }}>({option.description})</span>
              </Dropdown.Item>
            ))
        ) : (
          <Dropdown.Item disabled>No results found.</Dropdown.Item>
        )}
        <Dropdown.Item>
          <Button
            fluid
            onClick={() => {
              setOmitToUpdate({ omit, isSubtask, taskId });
              setNewOmitModalOpen(true);
              setDropdownOpen(false);
              setSearchQuery("");
            }}
          >
            Add New Omit Option
          </Button>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
